(function () {
  'use strict';

  var scrim = document.getElementById('search-scrim');
  var drawer = document.getElementById('search-drawer');
  var input = document.getElementById('search-input');
  var results = document.getElementById('search-results');
  var closeBtn = document.getElementById('search-close-btn');

  if (!drawer || !input) return;

  var debounceTimer = null;
  var lastQuery = '';
  var headerHeight = 0;

  function getHeaderHeight() {
    // The header sticks while the division bar scrolls away, so the drawer
    // must anchor to the header's actual on-screen bottom edge, not the sum
    // of both heights.
    var nav = document.getElementById('nav');
    if (!nav) return 72;
    return Math.max(Math.round(nav.getBoundingClientRect().bottom), 0);
  }

  function openSearch() {
    headerHeight = getHeaderHeight();
    drawer.style.paddingTop = headerHeight + 'px';
    scrim.style.top = headerHeight + 'px';

    scrim.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    input.focus();
  }

  function closeSearch() {
    scrim.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    input.value = '';
    results.innerHTML = '';
    lastQuery = '';
  }

  // --- toggle trigger ---
  document.addEventListener('click', function (e) {
    if (e.target.closest('#search-toggle')) {
      e.preventDefault();
      drawer.classList.contains('is-open') ? closeSearch() : openSearch();
      return;
    }
    if (e.target.closest('#search-close-btn') || e.target === scrim) {
      closeSearch();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeSearch();
  });

  // --- money format ---
  // Predictive search returns price in MAJOR units as a decimal string,
  // e.g. "222.95" = KM 222,95 — unlike the Cart API, which returns cents.
  function fmt(price) {
    var n = typeof price === 'number' ? price : parseFloat(price);
    if (isNaN(n)) return '';
    if (typeof window.formatMoney === 'function') return window.formatMoney(Math.round(n * 100));
    var moneyFmt = (window.shopSettings && window.shopSettings.moneyFormat) || '{{amount}}';
    var amount = n.toFixed(2);
    var amountComma = amount.replace('.', ',');
    var amountNoDecimals = Math.round(n).toString();
    return moneyFmt
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals)
      .replace('{{amount_with_comma_separator}}', amountComma)
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount}}', amount);
  }

  // --- render ---
  function escHtml(s) {
    return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function ts(key, fallback) {
    var s = (window.theme_strings && window.theme_strings[key]) || fallback;
    // The translation app stores some locale strings HTML-encoded (e.g. &quot;) —
    // decode once so escHtml doesn't double-escape them into visible "&QUOT;".
    if (s && s.indexOf('&') !== -1) {
      var t = document.createElement('textarea');
      t.innerHTML = s;
      s = t.value;
    }
    return s;
  }

  // Locale-aware root ('/bs' on the Bosnian storefront) so suggestions,
  // links and shortcut URLs stay in the visitor's language.
  var ROOT = ((window.routes && window.routes.root) || '/').replace(/\/$/, '');

  // Smart keyword shortcuts: predictive search doesn't index tags, so match common
  // gender/category keywords to their S&D filter URLs directly.
  var KEYWORD_SHORTCUTS = [
    { terms: ['women', 'woman', 'ladies', 'female', 'žene', 'zene', 'ženska', 'zenska', 'mujer', 'senhora', 'mulher'], label: ts('shortcut_women', "Women's Fashion"), url: '/collections/fashion?filter.p.tag=women' },
    { terms: ['men', 'man', 'male', 'gents', 'muškarci', 'muskarci', 'muška', 'muska', 'hombre', 'homem'], label: ts('shortcut_men', "Men's Fashion"), url: '/collections/fashion?filter.p.tag=men' },
    { terms: ['dress', 'dresses', 'haljina', 'haljine', 'vestido', 'vestidos'], label: ts('shortcut_dresses', 'Dresses'), url: '/collections/fashion?filter.p.tag=dress' },
    { terms: ['skirt', 'skirts', 'suknja', 'suknje', 'falda', 'faldas', 'saia', 'saias'], label: ts('shortcut_skirts', 'Skirts'), url: '/collections/fashion?filter.p.tag=skirts' },
    { terms: ['top', 'crop top', 'topovi'], label: ts('shortcut_tops', 'Tops'), url: '/collections/fashion?filter.p.tag=top' },
  ];

  function getKeywordShortcuts(query) {
    var q = query.toLowerCase().trim();
    var matches = [];
    KEYWORD_SHORTCUTS.forEach(function (shortcut) {
      if (shortcut.terms.some(function (t) { return q === t || q.indexOf(t) !== -1 || t.indexOf(q) !== -1; })) {
        matches.push(shortcut);
      }
    });
    return matches;
  }

  function renderResults(data, query) {
    var res = data && data.resources && data.resources.results;
    if (!res) { results.innerHTML = '<p class="sr-empty">' + escHtml(ts('search_no_results', 'No results found.')) + '</p>'; return; }

    var products = res.products || [];
    var collections = res.collections || [];
    var shortcuts = getKeywordShortcuts(query);
    var html = '';

    // Show keyword shortcuts first if no products found or query matches gender/category
    if (shortcuts.length && (products.length === 0 || query.length <= 5)) {
      html += '<p class="sr-section-label">' + escHtml(ts('search_browse_collections', 'Browse collections')) + '</p>';
      html += '<div class="sr-collection-list">';
      shortcuts.forEach(function (s) {
        html += '<a href="' + escHtml(ROOT + s.url) + '" class="sr-collection-pill">';
        html += '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M3 9h18M9 21V9"/><rect x="3" y="3" width="18" height="18" rx="2"/></svg>';
        html += escHtml(s.label) + '</a>';
      });
      html += '</div>';
    }

    if (products.length) {
      html += '<p class="sr-section-label">' + escHtml(ts('search_products', 'Products')) + '</p>';
      html += '<div class="sr-product-grid">';
      products.forEach(function (p) {
        var imgSrc = '';
        if (p.featured_image && p.featured_image.url) imgSrc = p.featured_image.url;
        else if (p.featured_image && typeof p.featured_image === 'string') imgSrc = p.featured_image;
        else if (p.images && p.images[0]) imgSrc = typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src || p.images[0].url || '';
        else if (p.image && p.image.url) imgSrc = p.image.url;
        else if (p.image && p.image.src) imgSrc = p.image.src;

        var price = p.price ? fmt(p.price) : (p.price_min ? fmt(p.price_min) : '');

        html += '<a href="' + escHtml(p.url) + '" class="sr-product-card">';
        if (imgSrc) {
          html += '<img class="sr-product-img" src="' + escHtml(imgSrc) + '" alt="' + escHtml(p.title) + '" width="200" height="200" loading="lazy">';
        } else {
          html += '<div class="sr-product-img" style="display:flex;align-items:center;justify-content:center;background:var(--beige,#e6dfd5);">';
          html += '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="rgba(13,1,1,0.2)" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>';
          html += '</div>';
        }
        html += '<div class="sr-product-info">';
        html += '<div class="sr-product-title">' + escHtml(p.title) + '</div>';
        if (price) html += '<div class="sr-product-price">' + price + '</div>';
        html += '</div></a>';
      });
      html += '</div>';
    }

    if (collections.length) {
      html += '<p class="sr-section-label">' + escHtml(ts('search_collections', 'Collections')) + '</p>';
      html += '<div class="sr-collection-list">';
      collections.forEach(function (c) {
        html += '<a href="' + escHtml(c.url) + '" class="sr-collection-pill">';
        html += '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>';
        html += escHtml(c.title) + '</a>';
      });
      html += '</div>';
    }

    if (!products.length && !collections.length && !shortcuts.length) {
      html = '<p class="sr-empty">' + escHtml(ts('search_no_results', 'No results found.')) + ' "<strong>' + escHtml(query) + '</strong>"</p>';
    } else if (products.length || collections.length || shortcuts.length) {
      html += '<a href="' + ROOT + '/search?q=' + encodeURIComponent(query) + '" class="sr-view-all">' + escHtml(ts('search_see_all', 'See all results for "[terms]" →').replace('[terms]', query)) + '</a>';
    }

    results.innerHTML = html;
  }

  // --- fetch ---
  function fetchResults(query) {
    if (query === lastQuery) return;
    lastQuery = query;

    if (!query || query.length < 2) {
      results.innerHTML = '';
      return;
    }

    results.innerHTML = '<div class="sr-spinner"><div></div></div>';

    var url = ROOT + '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection' +
      '&resources[limit]=6' +
      '&resources[options][unavailable_products]=last';

    fetch(url)
      .then(function (r) {
        if (r.ok) return r.json();
        // Locale-prefixed endpoint may 404 — fall back to the primary locale.
        return fetch(url.replace(ROOT + '/', '/')).then(function (r2) { return r2.json(); });
      })
      .then(function (data) {
        if (input.value.trim() === query) renderResults(data, query);
      })
      .catch(function () {
        if (input.value.trim() === query) {
          results.innerHTML = '<p class="sr-empty">' + escHtml(ts('search_error', 'Something went wrong. Try again.')) + '</p>';
        }
      });
  }

  // --- debounced input ---
  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { fetchResults(q); }, 220);
  });

  // close if clicking a result link
  results.addEventListener('click', function (e) {
    if (e.target.closest('a')) closeSearch();
  });
})();
